import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Img } from 'react-image';
import { useMediaQuery } from 'react-responsive';
import useGetMediaCarouselMetadata from '../../services/wire/media-services';
import theme from '../../../assets/stylesheets/_settings.global.scss';

const PdfAttachment = ({ url, filename, size }) => (
  <div className="wire-media-carousel__pdf">
    <h3>pdf attached</h3>
    <p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-event="link_click"
        data-event-type="click"
      >
        {size ? `${filename} (${size})` : filename}
      </a>
    </p>
    <svg className="icon"><use href="#pdf" /></svg>
  </div>
);

PdfAttachment.propTypes = {
  url: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  size: PropTypes.string,
};

PdfAttachment.defaultProps = {
  size: null,
};

export default function MediaCarousel(props) {
  const { wireId, inFullWireView, showMediaGallery } = props;
  const elementId = `wire-${wireId}`;

  const [{ data }, getCarouselMetadata] = useGetMediaCarouselMetadata(wireId);

  React.useEffect(() => {
    getCarouselMetadata();
  }, [getCarouselMetadata]);

  React.useEffect(() => {
    if (data) {
      Livewire.Wire.initCarousel($(`#${elementId}`));
    }
  }, [data, elementId]);

  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });

  if (isMobile && !inFullWireView) {
    return null;
  }

  return (
    <div id={elementId}>
      {
        data && (
        <ul className="wire-media-carousel">
          {data.media.map(m => {
            const filename = _(m.url).split('/').last();
            const isPDF = _.lowerCase(_(filename).split('.').last()) === 'pdf';
            const pdfProps = { ...m, filename: _.truncate(filename, { length: 40 }) };

            if (!isPDF && !showMediaGallery) {
              return null;
            }

            return (
              <li className="bxslider-inner" key={m.url}>
                {isPDF && <PdfAttachment {...pdfProps} />}
                {showMediaGallery && <Img className="margin-centered" src={m.url} alt={filename} />}
              </li>
            );
          })}
          {data.attachments.map(att => (
            <li className="bxslider-inner" key={att.url}>
              <PdfAttachment
                {...{ ...att, filename: _.truncate(_(att.url).split('/').last(), { length: 40 }) }}
              />
            </li>
          ))}
        </ul>
        )
      }
    </div>
  );
}

MediaCarousel.propTypes = {
  wireId: PropTypes.number.isRequired,
  inFullWireView: PropTypes.bool.isRequired,
  showMediaGallery: PropTypes.bool.isRequired,
};
